import * as React from 'react'
import { makeRandomAlphaNumericString } from '../../../../../../../utilities/helpers'
import { PurchaseOrderReceipt } from '@getgreenline/homi-shared'
import { POImportProductItemAdmin } from './POImportProductItemAdmin'
import { CurrentCompanyStore } from '../../../../../../../stores/CurrentCompanyStore'
import { Alert, Icon } from 'antd'

interface Props {
  companyId: number
  receiptResponse: PurchaseOrderReceipt
  currentCompanyStore: CurrentCompanyStore
  categoryWarningCount: number
}

// This component is only for admin users for now
export const POImportProductsAdmin = (props: Props) => {
  const { companyId, receiptResponse, currentCompanyStore, categoryWarningCount } = props
  const { foundInProductListing, foundInCatalogue, notFound } = receiptResponse

  const productNameId = `product-list__product-name-${makeRandomAlphaNumericString()}`
  const unshippedOrEmptyCategoryCount = foundInProductListing.filter(
    (listing) => listing.caseCount === 0 || !listing.productDetail.categoryId,
  ).length
  const totalProductCount = foundInProductListing.length + foundInCatalogue.length + notFound.length
  const showWarning = categoryWarningCount === 0

  const warningAlert = () => {
    return (
      <div className='d-flex justify-content-center align-items-center'>
        <Icon
          className='mr-2'
          type='exclamation-circle'
          theme='filled'
          style={{ color: 'var(--yellow)' }}
        />
        Please click product names to update Vendor, Taxes, and Price
      </div>
    )
  }

  return (
    <section className='product-list-wrapper'>
      {showWarning && (
        <Alert
          type='warning'
          className='mb-3'
          message={warningAlert()}
          style={{ borderRadius: '0.6rem', marginTop: '-0.875rem' }}
        />
      )}

      <h6 className='pt-2 pb-2'>
        {`${
          foundInProductListing.length - unshippedOrEmptyCategoryCount
        } / ${totalProductCount} products can be imported`}
      </h6>

      <ul className='rounded product-list product-list__found'>
        {foundInProductListing.map((product, index) => {
          return (
            <div key={`${product.productDetail.id}-${index}`}>
              <POImportProductItemAdmin
                companyId={companyId}
                product={product}
                productNameId={productNameId}
                currentCompanyStore={currentCompanyStore}
              />
            </div>
          )
        })}
      </ul>
    </section>
  )
}
